import { render, staticRenderFns } from "./UploadZoneFileItem.vue?vue&type=template&id=c65608ca"
import script from "./UploadZoneFileItem.vue?vue&type=script&lang=js"
export * from "./UploadZoneFileItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports